import axiosInterceptor from 'src/app/axiosInterceptor';
const pendingRequests = new Map();
export const deduplicatedFetch = (url, config = {}) => {
  const key = url + (config.params ? JSON.stringify(config.params) : '');
  if (pendingRequests.has(key)) { return pendingRequests.get(key); }
  const promise = axiosInterceptor.get(url, config).then(response => { setTimeout(() => pendingRequests.delete(key), 1000); return response; })
    .catch(error => {
      setTimeout(() => pendingRequests.delete(key), 1000); throw error;
    });
  pendingRequests.set(key, promise);
  return promise;
};